import CreateProductForm from './CreateProductForm';
import { ProductType } from '../../../models/Product/contracts';

function CreateProduct() {
  return (
    <>
      <h1 className="cs-title">Dodavanje proizvoda</h1>
      <CreateProductForm productType={ProductType.SIMPLE} />
    </>
  );
}

export default CreateProduct;
